export function formatMoney({ cents, currency }, locale) {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        // Québec formats CAD as "19,99 $" in French and "$19.99" in English. Intl
        // already knows; we must not hand-assemble it.
    }).format(cents / 100);
}
/**
 * Tax rates arrive as parts per million, not basis points — QST is 9.975%,
 * which is 997.5 basis points and would not survive an integer field.
 */
export function formatTaxRate(ratePpm, locale) {
    return new Intl.NumberFormat(locale, {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
    }).format(ratePpm / 1_000_000);
}
//# sourceMappingURL=money.js.map